import { ProviderService } from "../../models/provider/provider-service.model";

export interface IProviderServiceState {
    providerGuid: string | null;
    providerServices: ProviderService[];
    currentProviderService: ProviderService | null;
    loading: boolean;
    saving: boolean;
    deleting: boolean;
    error: string | null;
}

export const initialProviderServiceState: IProviderServiceState = {
    providerGuid: null,
    providerServices: [],
    currentProviderService: null,
    loading: false,
    saving: false,
    deleting: false,
    error: null
};
